export const theme = {
	darkGray: "#15171E",
	lightGray: "#393E46",
	orange: "#D65A31",
	darkOrange: "#994023",
	white: "#EEEEEE",
	fontSize: "1em",
	fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;',
};
